import { isAuthenticated } from "../../utils/identityUtils";
import { isPremierAvailable, getCountryEndpoint } from "../../helpers";
import { setOfferedFreeTrial } from "../PremierPageFrame";
import { fetchDelivery } from "../PremierPricingTable";
import { resetSubscriptionButton } from "../PremierProposition";
import { getSegmentIds } from "../../utils/getSegmentIds";

export const FETCH_COUNTRY = "FETCH_COUNTRY";
export const FETCH_COUNTRY_ERROR = "FETCH_COUNTRY_ERROR";
export const RECEIVE_COUNTRY = "RECEIVE_COUNTRY";

function fetchCountryData() {
  return {
    type: FETCH_COUNTRY,
  };
}

export function receiveCountry(data, premierAvailable) {
  return {
    type: RECEIVE_COUNTRY,
    countryData: data.subscriptionOptions && data.subscriptionOptions[0],
    premierAvailable,
  };
}

export function fetchError(err) {
  return {
    type: FETCH_COUNTRY_ERROR,
    apiError: err,
  };
}

const getSegmentsHeader = async (additionalHeaders) => {
  const response = await getSegmentIds();
  if (response.length > 0) {
    const segmentIds = response.map((segment) => segment.segmentId).join(",");
    additionalHeaders["asos-c-segmentids"] = segmentIds;
  }
  return additionalHeaders;
};

export function fetchCountry(
  countryCode,
  language,
  currency,
  storeId,
  countries
) {
  return async (dispatch) => {
    const premierAvailable = isPremierAvailable(countryCode, countries);
    const premierAvailability =
      premierAvailable === 0
        ? false
        : !!isPremierAvailable(countryCode, countries);
    const code = premierAvailability ? countryCode : "GB";

    const isLoggedIn = await isAuthenticated();

    const countryEndpoint = getCountryEndpoint(
      code,
      currency,
      language,
      isLoggedIn
    );
    dispatch(fetchCountryData());
    dispatch(fetchDelivery(countryCode, currency, storeId));
    let additionalHeaders = {};

    if (isLoggedIn) {
      additionalHeaders = await getSegmentsHeader(additionalHeaders);
    }

    return fetch(countryEndpoint, { headers: additionalHeaders })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return dispatch(fetchError(response.message));
      })
      .then((data) => {
        dispatch(resetSubscriptionButton());
        dispatch(receiveCountry(data, premierAvailability));
        if (isLoggedIn) {
          dispatch(
            setOfferedFreeTrial(!!data?.subscriptionOptions[0]?.trialOffer)
          );
        }
      })
      .catch((err) => {
        dispatch(fetchError(err.message));
      });
  };
}
